module.exports = __webpack_public_path__ + "img/katarina_amenities_8.41f16814.jpg";